import { render, staticRenderFns } from "./PersonalCompetitionForm.vue?vue&type=template&id=554d9fdc&scoped=true&"
import script from "./PersonalCompetitionForm.vue?vue&type=script&lang=js&"
export * from "./PersonalCompetitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d9fdc",
  null
  
)

export default component.exports